<template>
  <v-app id="app">
    <v-progress-linear class="app-progress" :active="$store.state.activeRequests.length" indeterminate></v-progress-linear>
    <v-content>
      <v-flex class="alert">
        <v-alert style="width:max-content;" v-model="alert" type="error" dismissible transition="scale-transition">
          <p v-for="text in $store.state.errorList">{{ text }}</p>
        </v-alert>
      </v-flex>
      <v-container fluid fill-height>        
        <v-layout align-center justify-center>
          <router-view></router-view>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  export default {
    data: () => ({
      alert: false,
    }),
    mounted() {      
    },
    methods: {
    },
    computed: {
      errorList() {
        return this.$store.state.errorList;
      }
    },
    watch: {
      errorList(list) {
        if (list.length) {
          this.alert = true;
        }
      }, 
      alert(visible) {
        if (!visible) {
          this.$store.state.errorList = [];
        }
      }
    },
    components: {
    }
  }
</script>

<style scoped>
.alert {
  display: flex;
  padding: 4px;
  width: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
}
.app-progress {
  position: fixed;
  margin: 0;
  top: 0;
  z-index: 10000;
}
</style>



// WEBPACK FOOTER //
// App.vue?15c54410